import React from 'react'
import { Route, Switch } from 'react-router-dom'

import Senha from '../Senha/Senha'
import NovoProcesso from '../Processo/NovoProcesso'
import BuscaProcesso from '../Processo/BuscaProcesso'
import Processo from '../Processo/Processo'
import NovoAnexo from '../Anexo/NovoAnexo'
import Home from '../Home/Home'
import NovoDespacho from '../Despacho/NovoDespacho'
import DespachoView from '../Despacho/DespachoView'
import Portaria from '../Processo/Portaria'
import NovoChamado from '../Suporte/NovoChamado'
import MeusChamados from '../Suporte/MeusChamados'
import Chamado from '../Suporte/Chamado'
import CapaProcesso from '../Processo/CapaProcesso'

export default class Content extends React.Component {
    render() {
        return (
            <Switch>
                <Route exact path='/juridico/' component={Home} />
                <Route exact path='/juridico/senha' component={Senha} />
                <Route exact path='/juridico/NovoProcesso' component={NovoProcesso} />
                <Route exact path='/juridico/BuscaProcesso' component={BuscaProcesso} />
                <Route exact path='/juridico/Processo/:id' component={Processo} />
                <Route exact path='/juridico/NovoAnexo/:id' component={NovoAnexo} />
                <Route exact path='/juridico/NovoDespacho/:id' component={NovoDespacho} />
                <Route exact path='/juridico/DespachoView/:id' component={DespachoView} />
                <Route exact path='/juridico/Portaria/:id' component={Portaria} />
                <Route exact path="/Juridico/novoChamado" component={(NovoChamado)} />
                <Route exact path='/Juridico/meusChamados' component={MeusChamados} />
                <Route exact path={`/Juridico/chamado/:id`} component={Chamado} />
                <Route exact path='/juridico/CapaProcesso/:id' component={CapaProcesso} />
            </Switch>
        )
    }
}